import { ClientType } from "../enums/clientTypeEnum";

export interface Customer {
    id: string;
    createdAt: string;
    updatedAt: string | null;
    deletedAt: string | null;
    name: string;
    externalId: string;
    street: string;
    email: string;
    phone: string;
    documentFolder: string;
    comment: string;
    clientType?: ClientType;
    postalCode?: string;
    city?: string;
}

export const defaultCustomer: Customer = {
    id: '',
    createdAt: '',
    updatedAt: null,
    deletedAt: null,
    name: '',
    externalId: '',
    street: '',
    email: '',
    phone: '',
    documentFolder: '',
    comment: '',
    clientType: ClientType.Standard,
    postalCode: '',
    city: '',
};